import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { UserControls } from './UserControls';
import { UserIssuerIcon } from './UserIssuerIcon';
import { UserTableEditableCell } from './UserTableEditableCell';
function getEmailColumn(shardName) {
    return {
        dataIndex: 'email',
        key: 'email',
        render: (value, user) => React.createElement("div", { className: 'user-email-with-issuer' },
            React.createElement(UserIssuerIcon, { issuerType: user.issuerType }),
            React.createElement(UserTableEditableCell, { editable: user.issuerType === 'sonar', shardName: shardName, userId: user.id, userProperty: 'email', value: value })),
        title: ADMIN_DASHBOARD_COPY.EMAIL,
        width: 400
    };
}
function getFirstNameColumn(shardName) {
    return {
        dataIndex: 'firstName',
        key: 'firstName',
        render: (value, user) => React.createElement(UserTableEditableCell, { shardName: shardName, userId: user.id, userProperty: 'firstName', value: value }),
        title: ADMIN_DASHBOARD_COPY.FIRST_NAME,
        width: 150
    };
}
function getLastNameColumn(shardName) {
    return {
        dataIndex: 'lastName',
        key: 'lastName',
        render: (value, user) => React.createElement(UserTableEditableCell, { shardName: shardName, userId: user.id, userProperty: 'lastName', value: value }),
        title: ADMIN_DASHBOARD_COPY.LAST_NAME,
        width: 150
    };
}
function getIdColumn() {
    return {
        dataIndex: 'id',
        key: 'id',
        title: ADMIN_DASHBOARD_COPY.ID,
        width: 75
    };
}
function getControlsColumn(shardName) {
    return {
        dataIndex: 'actions',
        key: 'actions',
        render: (value, user) => React.createElement(UserControls, { shardName: shardName, user: user }),
        title: ADMIN_DASHBOARD_COPY.ACTIONS,
        width: 750
    };
}
export function getUserTableColumns(shardName) {
    return [
        getEmailColumn(shardName),
        getFirstNameColumn(shardName),
        getLastNameColumn(shardName),
        getIdColumn(),
        getControlsColumn(shardName)
    ];
}
export function getUserTableRowKey(user, shardName) {
    return `${user.id}:${shardName}`;
}
